import { API } from "apis";
import PageTitle from "components/common/PageTitle";
import { ContextModel, HideListItemModel } from "models";
import React from "react";
import { Helmet } from "react-helmet-async";
import { Link, useOutletContext } from "react-router-dom";
import { Utils } from "utils";

const HideListPage: React.FC = () => {
  const ctx = useOutletContext<ContextModel>();
  const didEffect = React.useRef(false);

  const [hideLists, setHideLists] = React.useState<HideListItemModel[]>([]);

  React.useEffect(() => {
    if (didEffect.current) {
      return;
    }
    didEffect.current = true;

    const f = async () => {
      ctx.loading.setState(true);
      await ctx.auth.initialize();
      await ctx.limitPrice.load();

      try {
        const hideLists = await API.HideList.list();
        setHideLists(hideLists.data);
      } catch (err) {
        Utils.errorAction(ctx, err);
      }
      ctx.loading.setState(false);
    };
    f();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div>
      <Helmet>
        <title>非公開リスト一覧</title>
      </Helmet>
      <PageTitle title="非公開リスト一覧" className="p-2" />

      <div className="mx-4 flex justify-end p-2">
        <Link to={`/non-disclosure-detail/`}>
          <button className="primary px-4 py-2">新規登録</button>
        </Link>
      </div>

      {hideLists.length > 0 ? (
        <>
          <div className="mx-4 px-16 border-b">
            <span className="font-bold text-xl">リスト名</span>
          </div>

          {hideLists.map((item, index) => {
            return (
              <Link
                to={`/non-disclosure-detail/${item.hide_list_id}/`}
                key={index}
              >
                <div key={index} className="mx-4 px-12 py-4 border-b">
                  {item.hide_list_name}
                </div>
              </Link>
            );
          })}
        </>
      ) : (
        <div className="flex justify-center py-12">
          <div>非公開リストがありません。</div>
        </div>
      )}
    </div>
  );
};
export default HideListPage;
